import { http } from "@/shared/api/axios"
import type { PaginatedResponse } from "@/shared/api/types"
import type {
  Client,
  UpsertClientRequest,
  DeactivateClientRequest,
  GetClientListRequest,
  LookupClientResponse,
} from "../model/types"

/**
 * Fetch paginated list of clients with filters
 */
export const fetchClients = async (
  params: GetClientListRequest
): Promise<PaginatedResponse<Client>> => {
  const response = await http.get<PaginatedResponse<Client>>('/v1/clients', {
    params,
  })
  return response.data
}

/**
 * Fetch a single client by ID
 */
export const fetchClient = async (id: number): Promise<Client> => {
  const response = await http.get<Client>(`/v1/clients/${id}`)
  return response.data
}

/**
 * Create a new client
 */
export const createClient = async (
  request: UpsertClientRequest
): Promise<Client> => {
  const response = await http.post<Client>('/v1/clients', request)
  return response.data
}

/**
 * Update an existing client
 */
export const updateClient = async (
  id: number,
  request: UpsertClientRequest
): Promise<Client> => {
  const response = await http.put<Client>(`/v1/clients/${id}`, request)
  return response.data
}

/**
 * Activate a client
 */
export const activateClient = async (id: number): Promise<void> => {
  await http.post(`/v1/clients/${id}/activate`)
}

/**
 * Deactivate a client
 */
export const deactivateClient = async (
  id: number,
  request: DeactivateClientRequest
): Promise<void> => {
  await http.post(`/v1/clients/${id}/deactivate`, request)
}

export const fetchClientLookup = async (ids?: number[], includeSites?: boolean): Promise<LookupClientResponse[]> => {
  const response = await http.get<LookupClientResponse[]>('/v1/lookup/client', {
    params: {
      ...(ids && ids.length > 0 ? { ids: ids.join(',') } : {}),
      ...(includeSites ? { includeSites: true } : {}),
    },
  })
  return response.data
}
